import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "components/common/Typography";
import colors from "styles/Colors";
import { tokens } from "styles/Tokens";
import { getUIFormatDate } from "utils/DateHelper";

const PlanStatsItem = (props: any) => {
  const { data } = props;
  let progressColor = colors.Neutral.Neutral300;
  const progress =
    data?.planTotalCardsCount > 0 ? Math.ceil((data?.planCompletedCardsCount / data?.planTotalCardsCount) * 100) : 0;

  if (progress < 100) {
    progressColor = colors.Neutral.Neutral600;
  } else {
    progressColor = colors.Green.Green500;
  }

  if (data?.planStatus === "Overdue") {
    progressColor = colors.Red.Red500;
  }

  return (
    <Stack
      spacing={2}
      direction="row"
      alignItems="center"
      sx={{ paddingX: "24px", marginBottom: "16px", "& p": { flex: 1 } }}
    >
      <Typography showBold variant="body2" color={tokens.Text.General.PrimaryHeadline}>
        {data?.innCode}
      </Typography>
      <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
        {data?.planStatus}
      </Typography>
      <Stack flex={1} direction="row" alignItems="center">
        <Box
          sx={{
            width: "64px",
            backgroundColor: colors.Neutral.Neutral300,
            height: "4px",
            borderRadius: "100px",
            marginRight: "8px",
            position: "relative",

            "&::after": {
              content: '""',
              position: "absolute",
              left: 0,
              top: 0,
              bottom: 0,
              width: `${progress}%`,
              backgroundColor: progressColor,
              borderRadius: "100px"
            }
          }}
        />
        <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
          {progress}%
        </Typography>
      </Stack>
      <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
        {data?.engagement || "-"}
      </Typography>
      <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
        {data?.planPriority || "-"}
      </Typography>
      <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
        {data?.planDueDate ? getUIFormatDate(data?.planDueDate) : "-"}
      </Typography>
      <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
        {data?.planCompletionDate ? getUIFormatDate(data?.planCompletionDate) : "-"}
      </Typography>
    </Stack>
  );
};

export default PlanStatsItem;
